import common from './common';
import home from './home';
import career from './career';
import about from './about';
import contact from './contact';
import projects from './projects';

export default {
  ...common,
  ...home,
  ...career,
  ...projects,
  ...about,
  ...contact,
};